export default __webpack_public_path__ + "static/media/radio_img1.c09de08e.png";